import tumKonular from '@/utils/json/konular.json'

export function konulariGetir (kur) {
  const res = []
  for (let i = 0; i < tumKonular.length; i++) {
    if (tumKonular[i].kur === kur.toString()) {
      res.push({
        value: parseInt(tumKonular[i].gun),
        text: `${tumKonular[i].gun}. Gün ${tumKonular[i].baslik}`
      })
    }
  }
  return res
}

export function konuAdiGetir (kur, gun) {
  for (let i = 0; i < tumKonular.length; i++) {
    if (tumKonular[i].kur === kur.toString() && tumKonular[i].gun === gun.toString()) {
      return `${tumKonular[i].gun}. Gün ${tumKonular[i].baslik}`
    }
  }
  if (parseInt(gun) > 24 && (parseInt(kur) === 1 || parseInt(kur) === 2)) {
    return 'KONULAR BİTMİŞ'
  }
  if (parseInt(gun) > 32 && parseInt(kur) === 3) {
    return 'KONULAR BİTMİŞ'
  }
  if (parseInt(gun) > 20 && parseInt(kur) === 5) {
    return 'KONULAR BİTMİŞ'
  }
  return 'Müfredat Girilmemiş'
}
